<template>
  <div class="pc-city-detail">
    <!-- city head -->
    <div class="pc-city-detail-head">
      <div class="pc-city-detail-head-bread">
        <h2>城市管理</h2>
        <BreadCrumb :data="breadcrumb" class="pc-city-detail-breadcrumb" />
      </div>
      <h4 v-show="editCity == false" @click="edit">管理</h4>
      <h4
        v-show="editCity == true && oprateType == 'update'"
        @click="
          edit();
          saveArea();
        "
      >
        完成
      </h4>
      <h4
        v-show="editCity == true && oprateType == 'add'"
        @click="
          edit();
          addcity();
        "
      >
        新增
      </h4>
    </div>
    <!-- city base info -->
    <div class="pc-city-base-info">
      <div class="pc-city-detail-information">
        <h2 v-if="editCity">修改信息</h2>
        <h2 v-else>基本信息</h2>
        <div class="content">
          <!-- 左边边图片 -->
          <div class="cover-img-info">
            <div class="content-cover-img">
              <el-upload
                v-if="editCity"
                class="logoImg"
                action="#"
                list-type="picture-card"
                accept=".png,.PNG,.jpg,.JPG,.jpeg"
                :http-request="uploadBgImage"
                :show-file-list="false"
                :auto-upload="true"
              >
                <img
                  v-if="cityDetail.bgImage"
                  :src="cityDetail.bgImage"
                  class="upload-image"
                />
                <p v-else class="img-hint">添加城市封面图</p>
              </el-upload>
              <div class="process" v-if="bgImagePercentage != 0">
                <el-progress
                  type="circle"
                  :width="100"
                  :percentage="bgImagePercentage"
                ></el-progress>
              </div>
              <img
                v-if="!editCity && cityDetail.bgImage"
                :src="cityDetail.bgImage"
                alt=""
              />
              <div class="img-alt" v-if="!editCity && !cityDetail.bgImage">
                <p class="iconfont icon-tupian"></p>
                <p>暂无城市封面图</p>
              </div>
              <p class="img-description">封面图尺寸：1：1</p>
              <!-- <el-input v-model="cityDetail.coverImage"></el-input> -->
            </div>
            <div class="content-shape-img">
              <el-upload
                v-if="editCity"
                class="logoImg"
                action="#"
                list-type="picture-card"
                accept=".png,.PNG,.jpg,.JPG,.jpeg"
                :http-request="uploadFormImage"
                :show-file-list="false"
                :auto-upload="true"
              >
                <img
                  v-if="cityDetail.formImage"
                  :src="cityDetail.formImage"
                  class="upload-image"
                />
                <p class="img-hint">添加城市形态</p>
              </el-upload>
              <div class="process" v-if="formImagePercentage != 0">
                <el-progress
                  type="circle"
                  :width="100"
                  :percentage="formImagePercentage"
                ></el-progress>
              </div>
              <img
                v-if="!editCity && cityDetail.formImage"
                :src="cityDetail.formImage"
                alt=""
              />
              <div class="img-alt" v-if="!editCity && !cityDetail.formImage">
                <p class="iconfont icon-tupian"></p>
                <p>暂无城市形态</p>
              </div>
              <!-- <el-input v-model="cityDetail.coverImage"></el-input> -->
            </div>
            <div class="base-info">
              <div class="long-term">
                <p class="title required">中文名称:</p>
                <el-input
                  v-if="editCity"
                  v-model="cityDetail.name"
                  placeholder="请输入中文名称"
                ></el-input>
                <p class="term-content" v-else>{{ cityDetail.name }}</p>
              </div>
              <div class="long-term">
                <p class="title">英文名称:</p>
                <el-input
                  v-if="editCity"
                  v-model="cityDetail.englishName"
                  placeholder="请输入英文名称"
                ></el-input>
                <p class="term-content" v-else>{{ cityDetail.englishName }}</p>
              </div>
              <div class="city-adcode-region">
                <div class="short-term">
                  <p class="title">城市编号:</p>
                  <el-input
                    v-if="editCity"
                    v-model="cityDetail.adcode"
                    placeholder="请输入城市编号"
                  ></el-input>
                  <p class="term-content" v-else>{{ cityDetail.adcode }}</p>
                </div>
                <div class="short-term">
                  <p class="title">所属城市群:</p>
                  <!-- <el-input
                    v-if="editCity"
                    v-model="cityDetail.cityGroupId"
                    placeholder="请输入所属城市群"
                  ></el-input> -->
                  <el-select
                    v-if="editCity"
                    v-model="cityDetail.cityGroupId"
                    clearable
                    placeholder="所属城市群"
                  >
                    <el-option
                      v-for="(item, index) in regions"
                      :key="index"
                      :value="item.id"
                      :label="item.name"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>

                  <p class="term-content" v-else-if="cityDetail.cityGroup">
                    {{ cityDetail.cityGroup.name }}
                  </p>
                </div>
              </div>
              <div class="city-continent-country">
                <div class="short-term">
                  <p class="title">大洲:</p>

                  <el-select
                    v-if="editCity"
                    v-model="cityDetail.continent"
                    clearable
                    placeholder="选择大洲"
                    @change="getCountryDicList($event)"
                  >
                    <el-option
                      v-for="(item, index) in continentList"
                      :key="index"
                      :value="item.name ? item.name : item.englishName"
                      :label="item.name ? item.name : item.englishName"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>

                  <p class="term-content" v-else>{{ cityDetail.continent }}</p>
                </div>
                <div class="short-term">
                  <p class="title">国家:</p>
                  <el-select
                    v-if="editCity"
                    v-model="cityDetail.country"
                    clearable
                    placeholder="选择国家"
                    :disabled="cityDetail.continent == null"
                    @change="getProvinceDicList()"
                  >
                    <el-option
                      v-for="(item, index) in countryList"
                      :key="index"
                      :value="item.name ? item.name : item.englishName"
                      :label="item.name ? item.name : item.englishName"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>

                  <p class="term-content" v-else>{{ cityDetail.country }}</p>
                </div>
                <div class="short-term">
                  <p class="title">省:</p>

                  <!-- <el-input
                    v-if="editCity"
                    v-model="cityDetail.province"
                    placeholder="请输入所属省"
                  ></el-input> -->

                  <el-select
                    v-if="editCity"
                    v-model="cityDetail.province"
                    clearable
                    placeholder="选择省"
                    :disabled="
                      cityDetail.continent == null || cityDetail.country == null
                    "
                  >
                    <el-option
                      v-for="(item, index) in provinceList"
                      :key="index"
                      :label="item.name ? item.name : item.englishName"
                      :value="item.name ? item.name : item.englishName"
                    ></el-option>
                  </el-select>

                  <p class="term-content" v-else>{{ cityDetail.province }}</p>
                </div>
              </div>
              <div class="city-status">
                <div class="short-term lat-lng">
                  <p class="title">坐标:</p>
                  <el-input
                    v-if="editCity"
                    v-model="cityDetail.lat"
                    placeholder="横坐标"
                  ></el-input>
                  <el-input
                    v-if="editCity"
                    v-model="cityDetail.lng"
                    placeholder="纵坐标"
                  ></el-input>
                  <p class="term-content" v-else>
                    {{ cityDetail.lat }},{{ cityDetail.lng }}
                  </p>
                </div>
                <div class="short-term">
                  <p class="title">状态</p>
                  <el-switch
                    v-if="editCity"
                    v-model="cityDetail.status"
                    active-color="#91CC75"
                    inactive-color="#C7C7C7"
                    :active-value="1"
                    :inactive-value="0"
                    style="align-self: center"
                  >
                  </el-switch>
                  <p v-else class="term-content">
                    {{ cityDetail.status ? "有效" : "失效" }}
                  </p>
                </div>
              </div>

              <div></div>
            </div>
          </div>
          <div class="intro">
            <div class="chinese-intro">
              <p class="title">中文简介:</p>
              <el-input
                v-if="editCity"
                type="textarea"
                v-model="cityDetail.intro"
                placeholder="请输入中文简介"
              ></el-input>
              <p class="term-content" v-else>{{ cityDetail.intro }}</p>
            </div>

            <Translate v-if="editCity" @translateContent="translateContent" />

            <div class="english-intro">
              <p class="title">英文1简介:</p>
              <el-input
                v-if="editCity"
                type="textarea"
                v-model="cityDetail.englishIntro"
                placeholder="请输入英文简介"
              ></el-input>
              <p class="term-content" v-else>{{ cityDetail.englishIntro }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- city tags -->
    <TagDetail
      :dataDetail="cityDetail"
      :managerState="editCity"
      :filterArr="filterArr"
      @updateTag="updateTag"
    />
    <PhotoEdit
      :dataDetail="cityDetail.images"
      :editCity="editCity"
      @updateImage="updateCityImage"
      @deleteImage="deleteImage"
    >
      <template v-slot:header>
        <h2>城市照片编辑</h2>
      </template>
    </PhotoEdit>

    <VideoEdit
      :dataDetail="cityDetail.videos"
      :editCity="editCity"
      @updateImage="updateCityVideos"
      @deleteImage="deleteVideos"
    >
      <template v-slot:header>
        <h2>城市视频编辑</h2>
      </template>
    </VideoEdit>

    <MapEdit
      :dataDetail="cityDetail.maps"
      :editCity="editCity"
      @updateImage="updateCityMaps"
      @deleteImage="deleteMaps"
    >
      <template v-slot:header>
        <h2>历史地图编辑</h2>
      </template>
    </MapEdit>
    <CityDetaiData
      ref="basicData"
      :dataDetail="cityDetail.basicData"
      :editCity="editCity"
      :cityName="cityDetail.name"
    />
    <CityInnovativeIndex
      ref="innovativeData"
      :dataDetail="cityDetail.basicData"
      :editCity="editCity"
    />
     <div class="pc-city-button" v-show="editCity == true">
      <h4
        @click="edit(); getCity()"
        v-show="oprateType == 'update'"
      >
        恢复
      </h4>
      <h4 @click="edit();
          saveArea()">保存</h4>
    </div>
 
   <div class="allTemplate" v-show="findTemplate">
      <!-- 中间提示框 -->
      <div class="allTemplate-prompt">
        <span>{{ msgTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Translate from "../../template/Translate.vue";
import BreadCrumb from "../../template/BreadCrumb";
import CityInnovativeIndex from "./cityDetail/cityInnovativeIndex.vue";
// import CityIQ
import TagDetail from "../../template/TagDetail";
import PhotoEdit from "./cityDetail/photoEdit";
import VideoEdit from "./cityDetail/videoEdit.vue";
import MapEdit from "./cityDetail/mapEdit.vue";
import CityDetaiData from "./cityDetail/cityDetailData.vue";
import {
  updateCity,
  getCity,
  addCity,
  getCityGroups,
  translate,
  getDictionaries,
} from "./cityDetail/cityDetail.gql";
export default {
  data() {
    return {
      formImagePercentage: 0,
      bgImagePercentage:0,
      continentList: [],
      countryList: [],
      provinceList: [],
      regionArgs: {
        keywords: null,
        take: 10,
        skip: 0,
        order: "-updateTime",
        status: 1,
      },
      // 翻译弹框
      findTemplate:false,
      // 翻译中的提示问题
      msgTitle:'正在翻译中，请不要点击其他地方',
      regions: [],
      cityId: "",
      // head
      breadName: "",
      editCity: false,
      oprateType: "",
      // info
      cityDetail: {
        tags: [],
        id: "",
        msgTitle: "城市",
        type: "CITY",
        images: [],
        videos: [],
        maps: [],
      },
      // tags
      // 过滤标签数组
      filterArr:[],
    };
  },
  async created() {
    if (this.$route.query.id == null) {
      this.oprateType = "add";
      this.edit();
    } else {
      this.cityId = await this.$route.query.id;
      this.oprateType = await "update";
      await this.getCity();
    }
    this.getRegions();
    this.getContinentDicList("map_position");
  },
  components: {
    Translate,
    VideoEdit,
    MapEdit,
    CityDetaiData,
    CityInnovativeIndex,
    PhotoEdit,
    BreadCrumb,
    TagDetail,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "地图管理", link: "" },
        { name: "城市管理", link: "/admin/cityList" },
        {
          name: this.breadName ? this.breadName : "添加城市",
          link: "",
        },
      ];
    },
  },
  methods: {
    getContinentDicList(type) {
      this.$global
        .GraphqlQuery(this, getDictionaries, { type: type })
        .then((res) => {
          this.continentList = res.data;
        });
    },
    getCountryDicList() {
      console.dir();
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: ("map_position_" + this.cityDetail.continent)
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.countryList = res.data;
        });
    },
    getProvinceDicList() {
      this.$global
        .GraphqlQuery(this, getDictionaries, {
          type: (
            "map_position_" +
            this.cityDetail.continent +
            "_" +
            this.cityDetail.country
          )
            .replace(" ", "_")
            .toLowerCase(),
        })
        .then((res) => {
          this.provinceList = res.data;
        });
    },
    test(a) {
      console.log(a);
    },

    translateContent(arg) {
      this.findTemplate=true
      this.msgTitle='正在翻译中，请不要点击其他地方'
       let content = "";
      let flag = ''
      if (arg == "cTe") {
        content = this.cityDetail.intro;
        flag = '1'
      } else {
        content = this.cityDetail.englishIntro;
        flag = '2'
      }
      this.$global
        .GraphqlMutation(this, translate, {
          data: content,
          flag:flag
        })
        .then((res) => {
          this.findTemplate=false
          if (arg == "cTe") {
            this.$set(this.cityDetail, "englishIntro", res.data);
          } else {
            this.$set(this.cityDetail, "intro", res.data);
          }
        }).catch(err => {
          this.msgTitle = "出现异常了";
          setTimeout(() => {
            this.findTemplate = false;
          }, 2000);
        });
    },
    getRegions() {
      this.$global
        .GraphqlQuery(this, getCityGroups, this.dataArgs)
        .then((res) => {
          this.regions = res.data;
        });
    },

    updateCityImage(url, name) {
      this.cityDetail.images.push({
        image: url,
        title: name,
      });
    },
    deleteImage(id) {
      this.cityDetail.images.splice(id, 1);
    },
    updateCityMaps(url, name) {
      this.cityDetail.maps.push({
        image: url,
        title: name,
      });
    },
    deleteMaps(id) {
      this.cityDetail.maps.splice(id, 1);
    },
    updateCityVideos(url, name) {
      this.cityDetail.videos.push({
        video: url,
        title: name,
      });
    },
    deleteVideos(id) {
      this.cityDetail.videos.splice(id, 1);
    },
    edit() {
      // this.managerState = (this.managerState == false) == true ? true : false;
      this.editCity = (this.editCity == false) == true ? true : false;
    },
    getCity() {
      this.$global
        .GraphqlQuery(this, getCity, {
          // Parameters
          id: this.cityId,
          path:""
        })
        .then((res) => {
          this.cityDetail = res.data[0];
          this.cityDetail.msgTitle = "城市";
          this.filterArr = []
          this.filterArr.push(this.cityDetail.country)
          this.filterArr.push(this.cityDetail.continent)
          this.filterArr.push(this.cityDetail.province)
          if(this.cityDetail.cityGroup){
          this.filterArr.push(this.cityDetail.cityGroup.name)
          this.filterArr.push(this.cityDetail.cityGroup.englishName)
          }
          
          this.breadName = this.cityDetail.name;
          if (this.cityDetail.continent) {
            this.getCountryDicList();
          }
          if (this.cityDetail.continent && this.cityDetail.country) {
            this.getProvinceDicList();
          }
        });
    },
    addcity() {
      const subEntity = this.setData();
      this.$global
        .GraphqlMutation(this, addCity, {
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.oprateType = "update";
          // this.cityDetail.id = res.data[0].id;
          this.cityId = res.data[0].id;
          this.$global.success(this, "操作成功");
          this.$router.push({
            path: "/admin/cityDetail",
            query: { id: res.data[0].id },
            name: "cityDetail",
            params: res.data[0],
          });
          this.getCity();
        });
    },
    setData() {
      let {
        status,
        englishName,
        name,
        adcode,
        continent,
        country,
        province,
        lng,
        lat,
        formImage,
        bgImage,
        intro,
        englishIntro,
        cityGroupId,
        tags,
        images,
        videos,
        maps,
        basicData,
      } = this.cityDetail;
      let basic = this.$refs.basicData.getBasicData();
      let innovativeData = this.$refs.innovativeData.getInnovativeData();
      if (!images) {
        images = [];
      }
      if (!maps) {
        maps = [];
      }
      if (!videos) {
        videos = [];
      }
      // if (status==undefined) {
      //   status = 1;
      // }

      basicData = [];
      basicData.push(basic.area);
      basicData.push(basic.population);
      basicData.push(basic.gdp);
      basicData = basicData.concat(innovativeData);

      const subEntity = {
        status,
        englishName,
        name,
        adcode,
        continent,
        country,
        province,
        lng,
        lat,
        formImage,
        bgImage,
        intro,
        englishIntro,
        cityGroupId,
        tags,
        images,
        videos,
        maps,
        basicData,
      };
      return subEntity;
    },
    saveArea() {
      let subEntity = this.setData();
      this.$global
        .GraphqlMutation(this, updateCity, {
          // Parameters
          id: this.cityDetail.id,
          data: this.$global.checkNull(subEntity),
        })
        .then((res) => {
          this.loading = false;
          this.$global.success(this, "操作成功");
          this.getCity();
        });
    },
    async uploadBgImage(params) {
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.bgImagePercentage = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.bgImagePercentage = 0;
        this.$set(this.cityDetail, "bgImage", res.url.split("?")[0]);
      });
    },
    async uploadFormImage(params) {
      let config = {
        onUploadProgress: (progressEvent) => {
          process =
            (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
          this.formImagePercentage = parseInt(process);
        },
      };
      this.$global.uploadImageWithConfig(this, params, config).then((res) => {
        this.formImagePercentage = 0;
        this.$set(this.cityDetail, "formImage", res.url.split("?")[0]);
      });
    },
    updateTag(tags) {
      this.cityDetail.tags = tags;
    },
  },
};
</script>

<style scoped lang="scss">
.pc-city-detail {
  .pc-city-button {
    display: flex;
    justify-content: center;
    align-items: center;
    h4 {
      // margin-top: -10px;
      align-self: center;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 20px;
      margin-top: 40px;
    }
    h4:first-of-type {
      background: rgba(84, 112, 198, 0.14);
      color: $pageViewSmall;
      margin-right: 30px;
    }
    // h4:last-of-type{

    // }
  }
  .pc-city-detail-head {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $border-color;
    margin-top: 30px;
    padding-bottom: 15px;
    .pc-city-detail-head-bread {
      display: flex;
      h2 {
        align-self: flex-end;
        font-size: 18px;
        margin-right: 40px;
      }
      .pc-breadcrumb {
        margin-top: 26px;
      }
    }
    h4 {
      align-self: flex-end;
      font-size: 16px;
      background: $pageViewSmall;
      padding: 10px 29px 14px;
      font-weight: 400;
      color: $base-color;
      font-family: $english;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .pc-city-base-info {
    box-shadow: $boxshadow;
    padding: 35px 30px 0px;
    margin-top: 40px;
    .pc-city-detail-information {
      > h2 {
        border-bottom: 1px solid $border-color;
        font-size: 20px;
        padding-bottom: 15px;
        color: $mainTitle;
      }
      .content {
        padding: 31px 50px 60px 0px;
        .cover-img-info {
          display: flex;
          /deep/ .el-upload--picture-card {
            height: 169px;
            width: 175px;
          }
          .content-cover-img,
          .content-shape-img {
            margin-right: 30px;
            position:relative;
            .img-hint {
              font-size: 14px;
              line-height: 168px;
              color: #5470c6;
            }
            .img-description {
              font-size: 12px;
              color: $thirdTitle;
              margin-top: 10px;
            }
            img {
              border-radius: 6px;
              height: 167px;
              width: 173px;
            }
            .process {
              position: absolute;
              top: 0px;
              height: 167px;
              width: 173px;
              text-align: center;
              border-radius: 6px;
              border: 1px dashed $timeBtn;
              padding-top: 40px;
              // background: #fbfdff;
              /deep/ .el-progress__text{
                color:$base-color;
              }
            }
            .img-alt {
              height: 169px;
              width: 175px;
              background: $imgAlt;
              border-radius: 6px;
              padding-top: 50px;
              p {
                margin-bottom: 5px;
                color: $secondTitle;
                text-align: center;
              }
              .iconfont {
                font-size: 32px;
              }
            }
          }
          .base-info {
            width: 60%;
            .required::before{
              content: "*";
              color:red;
            }
            .city-adcode-region,
            .city-continent-country,
            .city-status {
              width: 100%;
              display: flex;
            }
            .long-term {
              /deep/ .el-input {
                width: 80%;
              }
            }
            .short-term {
              /deep/ .el-input {
                width: 50%;
              }
              /deep/ .el-switch {
                margin-top: -20px;
              }
            }
            .long-term,
            .short-term {
              display: flex;
              .el-select {
                /deep/ .el-input {
                  width: 90%;
                }
              }
              /deep/ .el-input {
                margin-bottom: 20px;
              }
              .title {
                flex-shrink: 0;
                margin-right: 20px;
                width: 110px;
                text-align: right;
                line-height: 40px;
                font-size: 16px;
              }
              .term-content {
                font-weight: bold;
                line-height: 40px;
              }
            }

            .lat-lng {
              /deep/ .el-input {
                width: 20%;
                margin-right: 10px;
              }
            }
          }
        }
        .intro {
          .title {
            width: 120px;
            flex-shrink: 0;
          }

          .chinese-intro,
          .english-intro {
            margin-bottom: 20px;
            display: flex;
            .term-content {
              font-weight: bold;
            }
          }
          .chinese-intro {
            .title {
              margin-top: 20px;
            }
            .term-content {
              margin-top: 20px;
            }
          }
        }
      }
    }
  }
}
.allTemplate {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    .allTemplate-prompt {
      display: flex;
      justify-content: center;
      align-self: center;
      cursor: pointer;
      background: $base-color;
      width: 30%;
      height: 200px;
      border-radius: 6px;
      span {
        align-self: center;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/admin/map/CityDetail.vue